<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">Administración</li>
  <li class="breadcrumb-item active">Módulos</li>
</ol>

<h1 class="page-header"><i class="fas fa-cubes"></i> Módulos de Evaluación<small> Administración</small></h1>

<div class="scrollable">
  <panel [noButton]="true">
    @if(!showForm){
    <div class="d-flex justify-content-between align-items-center mb-3">
      <span class="fs-5 fw-600">Lista de módulos</span>
      <button class="btn btn-sm btn-primary" (click)="newModule()"><i class="fas fa-plus me-1"></i>Nuevo módulo</button>
    </div>
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Acrónimo</th>
          <th>Ruta</th>
          <th class="text-center">Tipos respuesta</th>
          <th class="text-center">Grupos</th>
          <th class="text-center">Cálculo</th>
          <th class="text-center">Eval. mensual</th>
          <th class="text-center col-1"><i class="fas fa-cogs"></i></th>
        </tr>
      </thead>
      <tbody>
        @for(m of modules(); track m.id){
        <tr>
          <td class="fw-500">{{m.name}}</td>
          <td><code>{{m.acronym}}</code></td>
          <td><code>{{m.routeName || m.acronym}}</code></td>
          <td class="text-center small">
            @for(t of m.questionTypes; track t.id){
            <span class="badge bg-info me-1">{{t.label}}</span>
            }@empty {
            <span class="text-muted">Ninguno</span>
            }
          </td>
          <td class="text-center">
            <span class="badge" [ngClass]="(m.groupModules?.length || 0) > 0 ? 'bg-success' : 'bg-secondary'">
              {{m.groupModules?.length || 0}}
            </span>
          </td>
          <td class="text-center">
            <span class="badge" [ngClass]="m.scoringMode === 'annual' ? 'bg-warning text-dark' : 'bg-primary'">
              {{m.scoringMode === 'annual' ? 'Anual' : 'Mensual'}}
            </span>
          </td>
          <td class="text-center">
            @if (m.evaluateAllMonths) {
            <i class="fas fa-check-circle text-success" triggers="hover" ngbTooltip="Todas las preguntas cada mes"></i>
            }@else {
            <i class="fas fa-times-circle text-muted" triggers="hover" ngbTooltip="Por configuración individual"></i>
            }
          </td>
          <td class="text-center text-nowrap">
            <button class="btn btn-xs btn-ghost" (click)="editModule(m)" triggers="hover" ngbTooltip="Editar">
              <i class="fas fa-edit"></i>
            </button>
            <button class="btn btn-xs btn-ghost" (click)="toggleModule(m)" triggers="hover" [ngbTooltip]="m.enabled ? 'Deshabilitar' : 'Habilitar'">
              <i class="fas" [class.fa-toggle-on]="m.enabled" [class.fa-toggle-off]="!m.enabled"></i>
            </button>
          </td>
        </tr>
        }@empty {
        <tr><td colspan="8" class="text-center text-muted">No hay módulos registrados</td></tr>
        }
      </tbody>
    </table>
    }@else {
    <div>
      <h5 class="fw-600 mb-3">{{editing ? 'Editar' : 'Nuevo'}} módulo</h5>
      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label fw-500">Nombre</label>
          <input type="text" class="form-control" [formControl]="moduleForm.controls.name" placeholder="Ej: Auditoría de Secretaría" />
        </div>
        <div class="col-md-3 mb-3">
          <label class="form-label fw-500">Acrónimo</label>
          <input type="text" class="form-control" [formControl]="moduleForm.controls.acronym" placeholder="Ej: secretaria" />
        </div>
        <div class="col-md-3 mb-3">
          <label class="form-label fw-500">Nombre en ruta</label>
          <input type="text" class="form-control" [formControl]="moduleForm.controls.routeName" placeholder="Ej: secretaria" />
          <span class="text-muted small">Segmento de URL en el frontend (si se deja vacío se usa el acrónimo).</span>
        </div>
        <div class="col-md-3 mb-3 d-flex align-items-end">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="moduleEnabled" [formControl]="moduleForm.controls.enabled">
            <label class="form-check-label" for="moduleEnabled">Activo</label>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label fw-500">Descripción</label>
        <textarea class="form-control" rows="2" [formControl]="moduleForm.controls.description" placeholder="Descripción opcional..."></textarea>
      </div>

      <div class="mb-3">
        <label class="form-label fw-500">Modo de cálculo del puntaje</label>
        <select class="form-select w-auto" [formControl]="moduleForm.controls.scoringMode">
          <option value="monthly">Mensual (promedio por período)</option>
          <option value="annual">Anual (avance acumulado con metas)</option>
        </select>
      </div>

      <div class="mb-3">
        <label class="form-label fw-500">Tipos de respuesta permitidos</label>
        <span class="text-muted small d-block mb-2">Seleccione los tipos de pregunta disponibles para este módulo.</span>
        <div class="d-flex flex-wrap gap-2">
          @for(t of allQuestionTypes(); track t.id){
          <button type="button" class="btn btn-sm"
            [class.btn-primary]="selectedTypes.includes(t.id)"
            [class.btn-outline-secondary]="!selectedTypes.includes(t.id)"
            (click)="toggleQuestionType(t.id)">
            {{t.label}}
          </button>
          }
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label fw-500">Grupos del módulo</label>
        <span class="text-muted small d-block mb-2">Busque y seleccione los grupos que este módulo evaluará.</span>
        <ng-select
          [items]="allGroups"
          bindLabel="name"
          bindValue="id"
          [multiple]="true"
          [closeOnSelect]="false"
          [searchable]="true"
          [clearable]="true"
          placeholder="Seleccione grupos"
          [(ngModel)]="selectedGroupIds"
          [ngModelOptions]="{standalone: true}">
        </ng-select>
        @if(selectedGroupIds.length){
        <div class="mt-2 d-flex flex-wrap gap-1">
          @for(id of selectedGroupIds; track id){
          <span class="badge bg-primary">{{ groupName(id) }}</span>
          }
        </div>
        <small class="text-muted">{{ selectedGroupIds.length }} grupo(s) seleccionado(s)</small>
        }
      </div>

      <div class="mb-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="form-label fw-500 mb-0">Niveles de avance (% → color)</label>
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="addLevel()"><i class="fas fa-plus me-1"></i>Agregar nivel</button>
        </div>
        @if(editingLevels.length === 0){
        <span class="text-muted small d-block">Sin niveles definidos.</span>
        }
        @for(level of editingLevels; track $index; let i = $index){
        <div class="row g-2 align-items-center mb-2">
          <div class="col-md-2">
            <input type="number" class="form-control form-control-sm" min="0" max="100" [(ngModel)]="level.minPercent" placeholder="Mín %" />
          </div>
          <div class="col-md-2">
            <input type="number" class="form-control form-control-sm" min="0" max="100" [(ngModel)]="level.maxPercent" placeholder="Máx %" />
          </div>
          <div class="col-md-4">
            <input type="text" class="form-control form-control-sm" [(ngModel)]="level.label" placeholder="Etiqueta (Ej: Bajo, Medio, Alto)" />
          </div>
          <div class="col-md-2">
            <input type="color" class="form-control form-control-color form-control-sm" [(ngModel)]="level.color" />
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-xs btn-ghost text-danger" (click)="removeLevel(i)"><i class="fas fa-trash"></i></button>
          </div>
        </div>
        }
      </div>

      <div class="mb-3">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="evaluateAllMonths" [formControl]="moduleForm.controls.evaluateAllMonths">
          <label class="form-check-label" for="evaluateAllMonths">Evaluar todas las preguntas cada mes</label>
        </div>
      </div>

      <div class="d-flex gap-2">
        <button class="btn btn-primary" (click)="saveModule()"><i class="fas fa-save me-1"></i>Guardar</button>
        <button class="btn btn-outline-secondary" (click)="cancelForm()">Cancelar</button>
      </div>
    </div>
    }
  </panel>
</div>
